import React from 'react';
import { View, Text, StyleSheet, StyleProp, ViewStyle } from 'react-native';
import { useThemeColors } from '@/hooks/residents/useThemeColors';
import { REDESIGN_TYPOGRAPHY } from '@/constants/residents/homeConstants';

interface GreetingSectionProps {
  greeting: string;
  firstName: string;
  unitName: string;
  hasImage?: boolean;
  style?: StyleProp<ViewStyle>;
}

export const GreetingSection: React.FC<GreetingSectionProps> = React.memo(({
  greeting,
  firstName,
  unitName,
  hasImage = false,
  style,
}) => {
  const { colors } = useThemeColors();

  return (
    <View style={[styles.container, style]}>
      <Text style={[styles.title, { color: colors.text.primary }]}>
        {greeting}, {firstName}
      </Text>
      <View style={styles.subtitleRow}>
        {unitName ? (
          <Text
            style={[
              styles.subtitleText,
              { color: colors.text.dim },
              hasImage && { color: colors.text.imageSubtitle },
            ]}
          >
            {unitName}
          </Text>
        ) : null}
      </View>
    </View>
  );
});

GreetingSection.displayName = 'GreetingSection';

const styles = StyleSheet.create({
  container: {
    paddingTop: 24,
    gap: 6,
    marginBottom: 16,
  },
  title: {
    ...REDESIGN_TYPOGRAPHY.heading1,
  },
  subtitleRow: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 8,
  },
  subtitleText: {
    ...REDESIGN_TYPOGRAPHY.body,
  },
});
